import MusicLog from "../MusicLog";

export default function UserLogSection() {
  return (
      <MusicLog />
  );
}